import React from 'react';
import { CommentsProvider, type CommentsApi } from '@nodus/comments';
import api from '@/lib/api/core';

// Comments live on the core router which is mounted at the API root
// (``api.add_router("", core_router, …)`` in backend/core/urls.py),
// so the path is ``/comments/`` — NOT ``/core/comments/``.
const BASE = '/comments/';

const commentsApi: CommentsApi = {
  list: async ({ content_type, object_id, limit, offset }) => {
    const params: Record<string, string> = {
      content_type,
      object_id: String(object_id),
    };
    if (limit != null) params.limit = String(limit);
    if (offset != null) params.offset = String(offset);
    const response = await api.get(BASE, { params });
    return response.data;
  },
  create: async (body) => {
    const response = await api.post(BASE, body);
    return response.data;
  },
  update: async (id, body) => {
    const response = await api.patch(`${BASE}${id}/`, body);
    return response.data;
  },
  remove: async (id, force) => {
    await api.delete(`${BASE}${id}/`, force ? { params: { force: true } } : undefined);
  },
};

export const NodusCommentsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <CommentsProvider api={commentsApi}>{children}</CommentsProvider>
);
